import _ from 'lodash';
import moment from 'moment';

export function getHour(datetime, events) {
    datetime = moment(datetime).format();

    var date = {
        datetime: datetime,
        events: []
    };

    if (events && events.byDate && events.byHour[datetime]) {
        date.events = events.byHour[datetime].map(function (id) {
            return events.byId[id];
        });
    }

    return date;
}

export function getDate(datetime, events) {
    datetime = moment(datetime).format('YYYY-MM-DD');

    var date = {
        datetime: datetime,
        events: []
    };

    if (events && events.byDate && events.byDate[datetime]) {
        date.events = events.byDate[datetime].map(function (id) {
            return events.byId[id];
        });
    }

    return date;
}

export function getCalendar(dt, items) {

    if (!dt) {
        dt = moment();
    }

    var dtStart = moment(dt).startOf('month').startOf('isoweek').format('YYYY-MM-DD');
    var dtEnd = moment(dt).endOf('month').endOf('isoweek').format('YYYY-MM-DD');

    var events = {};

    if (items) {
        events = getEvents(items, dtStart, dtEnd);
    }

    var weeks = moment(dtEnd).diff(dtStart, 'week');

    var rows = [];

    for (var w = 0; w <= weeks; w++) {
        var datetime = moment(dtStart).add(w, 'weeks');

        datetime = moment(datetime).set('hour', 0);
        datetime = moment(datetime).set('minute', 0);
        datetime = moment(datetime).set('second', 0);

        var cols = [];

        for (var d = 0; d < 7; d++) {
            var date = getDate(datetime, events);

            datetime = moment(datetime).add(1, 'days');

            cols.push(date);
        }

        rows.push(cols);
    }

    var calendar = {
        dt: dt,
        dtStart: dtStart,
        dtEnd: dtEnd,
        rows: rows,
        events: events
    };

    return calendar;
}

export function getTimetable(dt, items, options) {
    var days = options.days;


    if (!days) {
        days = 1;
    }

    var dtStart = moment(dt).format('YYYY-MM-DD');
    var dtEnd = moment(dt).add(days, 'days').format('YYYY-MM-DD');

    var events = {};

    if (items) {
        events = getEvents(items, dtStart, dtEnd);
    }

    var cols = [];

    for (var d = 0; d < days; d++) {
        var datetime = moment(dtStart).add(d, 'days');

        datetime = moment(datetime).set('hour', 0);
        datetime = moment(datetime).set('minute', 0);
        datetime = moment(datetime).set('second', 0);

        var rows = [];

        for (var h = 0; h <= 23; h++) {
            datetime = moment(datetime).set('hour', h);
            datetime = moment(datetime).set('minute', 0);
            datetime = moment(datetime).set('second', 0);

            var hour = getHour(datetime, events);

            rows.push(hour);
        }

        cols.push(rows);
    }

    var timetable = {
        dt: dt,
        dtStart: dtStart,
        dtEnd: dtEnd,
        cols: cols,
        events: events
    };

    return timetable;
}

export function getSchedule(dt, items, options) {
    var months = options.months;


    if (!months) {
        months = 3;
    }

    var dtStart = moment(dt).format('YYYY-MM-DD');
    var dtEnd = moment(dt).add(months, 'months').format('YYYY-MM-DD');

    var events = {
        dates: []
    };

    if (items) {
        events = getEvents(items, dtStart, dtEnd);
    }

    var rows = [];

    for (var i = 0; i < events.dates.length; i++) {
        var _dt = events.dates[i];

        var datetime = moment(_dt);

        datetime = moment(datetime).set('hour', 0);
        datetime = moment(datetime).set('minute', 0);
        datetime = moment(datetime).set('second', 0);

        var date = getDate(datetime, events);

        rows.push(date);
    }

    var schedule = {
        dt: dt,
        dtStart: dtStart,
        dtEnd: dtEnd,
        rows: rows,
        events: events
    };

    return schedule;
}

export function getEvents(items, dtStart, dtEnd) {
    var dates = [];
    var hours = [];

    var byId = {};
    var byDate = {};
    var byHour = {};

    var sorted = _.sortBy(items, 'dtStart', 'dtEnd');

    for (var i = 0; i < sorted.length; i++) {
        var item = sorted[i];

        var id = item['uniqueId'];
        var date = moment(item['dtStart']).format('YYYY-MM-DD');
        var hour = moment(item['dtStart']);

        hour = moment(hour).set('minute', 0);
        hour = moment(hour).set('second', 0);
        hour = moment(hour).format();

        byId[id] = item;

        if (byDate[date]) {
            byDate[date].push(id);
        } else {
            byDate[date] = [id];
            dates.push(date);
        }

        if (byHour[hour]) {
            byHour[hour].push(id);
        } else {
            byHour[hour] = [id];
            hours.push(hour);
        }
    }

    var events = {
        dates: dates, hours: hours, byId: byId, byDate: byDate, byHour: byHour
    };

    return events;
}

export function getEventByHash(events, id) {
    var byId = events.byId;


    var event = {};

    if (byId[id]) {
        event = byId[id];
    }

    return event;
}